import React from 'react';
import { Crown, Trophy } from 'lucide-react';
import { ACHIEVEMENTS } from '@/lib/mockData';

const featured = ACHIEVEMENTS?.find((a) => a?.featured) ?? null;

export default function FeaturedChampion() {
  if (!featured) {
    return (
      <div
        className="relative rounded-2xl overflow-hidden p-8 mb-8"
        style={{
          background: 'linear-gradient(135deg, rgba(245,158,11,0.08) 0%, rgba(245,158,11,0.03) 50%, var(--card) 100%)',
          border: '1px dashed rgba(245,158,11,0.25)',
        }}
      >
        <div className="flex flex-col items-center justify-center py-8 gap-4 text-center">
          <div className="w-16 h-16 rounded-2xl flex items-center justify-center" style={{ background: 'rgba(245,158,11,0.1)', border: '1px solid rgba(245,158,11,0.2)' }}>
            <Trophy size={28} style={{ color: '#f59e0b' }} />
          </div>
          <div>
            <div className="flex items-center justify-center gap-2 mb-2">
              <Crown size={14} style={{ color: '#f59e0b' }} />
              <span className="text-xs font-bold uppercase tracking-widest" style={{ color: '#f59e0b' }}>Featured Champion</span>
            </div>
            <h2 className="text-xl font-bold mb-1" style={{ color: 'var(--foreground)' }}>No champion crowned yet</h2>
            <p className="text-sm max-w-sm" style={{ color: 'var(--muted-foreground)' }}>
              The featured champion spot is empty. Add achievements below to crown a champion.
            </p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div
      className="relative rounded-2xl overflow-hidden p-6 sm:p-8 mb-8 card-glow-gold"
      style={{
        background: 'linear-gradient(135deg, rgba(245,158,11,0.12) 0%, rgba(245,158,11,0.04) 50%, var(--card) 100%)',
        border: '1px solid rgba(245,158,11,0.3)',
      }}
    >
      <div
        className="absolute top-0 right-0 w-64 h-64 pointer-events-none"
        style={{ background: 'radial-gradient(circle at top right, rgba(245,158,11,0.12) 0%, transparent 70%)' }}
      />
      <div className="absolute top-4 right-4 opacity-10">
        <Trophy size={120} style={{ color: '#f59e0b' }} />
      </div>
      <div className="relative z-10">
        <div className="flex items-center gap-2 mb-6">
          <div className="flex items-center gap-2 px-3 py-1.5 rounded-full" style={{ background: 'rgba(245,158,11,0.15)', border: '1px solid rgba(245,158,11,0.3)' }}>
            <Crown size={14} style={{ color: '#f59e0b' }} />
            <span className="text-xs font-bold uppercase tracking-widest" style={{ color: '#f59e0b', letterSpacing: '0.08em' }}>
              Featured Champion
            </span>
          </div>
          <span className="text-xs font-semibold px-2 py-1 rounded-full" style={{ background: 'rgba(245,158,11,0.1)', color: '#fcd34d' }}>
            ✨ Legendary
          </span>
        </div>
        <div className="flex flex-col sm:flex-row items-start sm:items-center gap-6">
          <div className="relative flex-shrink-0">
            <div
              className="w-20 h-20 sm:w-24 sm:h-24 rounded-2xl flex items-center justify-center text-2xl sm:text-3xl font-extrabold"
              style={{ background: featured?.avatarColor, color: '#fff', boxShadow: '0 0 0 3px #f59e0b, 0 0 30px rgba(245,158,11,0.5)' }}
            >
              {featured?.initials}
            </div>
            <div className="absolute -top-2 -right-2 w-8 h-8 rounded-full flex items-center justify-center" style={{ background: '#f59e0b', color: '#0a0a0f' }}>
              <Crown size={16} />
            </div>
          </div>
          <div className="flex-1">
            <div className="flex flex-wrap items-center gap-3 mb-2">
              <h2 className="text-2xl sm:text-3xl font-extrabold" style={{ color: 'var(--foreground)' }}>{featured?.displayName}</h2>
              <span className="text-base font-medium" style={{ color: 'var(--muted-foreground)' }}>{featured?.username}</span>
            </div>
            <div className="flex items-center gap-2 mb-4">
              <span className="text-3xl">{featured?.icon}</span>
              <div>
                <p className="text-xl font-extrabold" style={{ color: '#f59e0b' }}>{featured?.title}</p>
                <p className="text-sm" style={{ color: 'var(--muted-foreground)' }}>{featured?.description}</p>
              </div>
            </div>
            <div className="flex flex-wrap gap-4">
              <div>
                <p className="text-2xl font-extrabold text-tabular" style={{ color: '#fcd34d' }}>{featured?.stat}</p>
                <p className="text-xs font-medium" style={{ color: 'var(--muted-foreground)' }}>{featured?.statLabel}</p>
              </div>
            </div>
          </div>
        </div>
        <div className="mt-4 pt-4 flex items-center gap-2" style={{ borderTop: '1px solid rgba(245,158,11,0.15)' }}>
          <span className="text-xs" style={{ color: 'var(--muted-foreground)' }}>Achievement unlocked:</span>
          <span className="text-xs font-semibold" style={{ color: '#f59e0b' }}>{featured?.unlockedAt}</span>
        </div>
      </div>
    </div>
  );
}